import {DICCIONARIO} from '../constants/Diccionario'
import {REGEX_USER_NAME} from '../constants/Regex'

export const validate = (input: any, name: string, errors: any) => {
  switch (name) {
    case 'email':
      if (!input.email.trim()) errors.email = `${DICCIONARIO.USERNAME} es requerido`
      else if (!REGEX_USER_NAME.test(input.email.trim()))
        errors.email = `${DICCIONARIO.USERNAME} inválido`
      else errors.email = ''
      break
    case 'password':
      if (!input.password.trim()) errors.password = `${DICCIONARIO.PASSWORD} es requerida`
      else errors.password = ''
      break
    default:
      break
  }
  return errors
}

export const validateClicLogin = (form: any) => {
  let errors: any = {}
  if (!form.email.trim()) errors.email = `${DICCIONARIO.USERNAME} es requerido`
  else if (!REGEX_USER_NAME.test(form.email.trim()))
    errors.email = `${DICCIONARIO.USERNAME} inválido`

  if (!form.password.trim()) errors.password = `${DICCIONARIO.PASSWORD} es requerida`

  if (Object.keys(errors).length !== 0) return errors
  return false
}
